import React from 'react';

import { StyledListItem } from './BlockListItemStyles';

/**
 * Render list item in rich text
 *
 * @param {React.ReactNode} children
 *
 * @returns {React.ReactElement}
 */
function BlockListItem({ children }) {
  let listText = children[0].props.children[0];
  const plus = listText?.toString().startsWith('[+]');
  if (plus) children[0].props.children[0] = listText.replace(/\[\+]\s?/, '');
  const minus = listText?.toString().startsWith('[-]');
  if (minus) children[0].props.children[0] = listText.replace(/\[-]\s?/, '');

  return (
    <StyledListItem disablePadding $plus={plus} $minus={minus}>
      {children}
    </StyledListItem>
  );
}

export default BlockListItem;
